export const LOGO = `${process.env.PUBLIC_URL || ""}/logo.webp`;

// Served from /public (same origin): no external request, and a missing file just hides the image.
export function Logo({ size = 36, className = "" }) {
  return (
    <img src={LOGO} alt="" width={size} height={size}
      onError={(e) => { e.currentTarget.style.display = "none"; }}
      style={{ width: size, height: size, objectFit: "contain", borderRadius: "50%" }}
      className={className} data-testid="brand-logo" />
  );
}

export function Wordmark({ logoSize = 32, className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <Logo size={logoSize} />
      <span className="font-bold text-[17px] tracking-tight">
        e-diki<span style={{ color: "var(--gold)" }}>Μου</span>
      </span>
    </div>
  );
}
